export default __webpack_public_path__ + "static/media/canal-denuncia.1eefa6e6.png";